import React from "react";
import Header from "../header";
import Footer from "../footer/footer";
// import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useState } from "react";
import "./layout.css";

const Layout = ({ children }) => {
  const [signup, setSignup] = useState(false);

  // const handleScroll = () => {
  //   const checkAuth = localStorage.getItem("token");
  //   console.log("checkAuth--->", checkAuth);
  //   if (checkAuth) {
  //     return;
  //   }
  //   if (window.scrollY >= 300) {
  //     setSignup(true);
  //   } else {
  //     setSignup(false);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <>
      <Helmet>
        <body className={signup ? "modal-scroll" : ""} />
      </Helmet>
      <div className='layout'>
        <Header signup={signup} setSignup={setSignup} />
        <div className='content'>{children}</div>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
